import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import CandidateTab from './CandidateTab';
import NotificationPanels from './NotificationPanels';
import PersonalDetailsIcon from '../assets/img/personal-details-icon.png';
import '../assets/css/candidate-tab-form.css';
import CalendarIcon from '../assets/img/calendar-icon.svg';
import PercentIcon from '../assets/img/percent-icon.png';
import QuestionIcon from '../assets/img/question-icon.png';
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import { useDispatch, useSelector } from "react-redux";
import ProgressHeading from './Common/ProgressHeading.jsx';

const CandidateOnboardingDetails = ()=> {

  //Handling Form Reference
  const form = useRef();
  const [role,setRole]=useState();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    currentLocation : null,
    religion : null,
    uanNo : null,
    epfNomineeName : null,
    epfNomineeRelation : null,
    epfNomineeDOB : null,
    epfNomineeAmountShare : null,
    epfNomineeAddress : null,

    epsNomineeName : null,
    epsNomineRelation : null,
    epsNomineAge : null,
    epsNomineAddress : null,

    graduityDetailsBankAcc : null,
    graduityDetailsIFSC : null,
    graduityDetailsExcludedSpouseDate : null,
    graduityNomineeName : null,
    graduityNomineeRelation : null,
    graduityNomineeDOB : null,
    graduityNomineeAmountShare : null
  });


  //Handling Floating Labels
  const handleFloatingLabels = (e)=> {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

    return (
      <>

      <NotificationPanels/>
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header/>
      <Sidebar/> */}

      <section className="main-section candidate-tab-form" style={{paddingTop: '60px'}}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"onboardingDetails"}/>
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}

              <form ref={form} className="p-3 form2 form-section">
              <StepCount activeTab={"onboardingDetails"}/>
                <h2 className="fnt-smi-bld">Onboarding Details</h2>
                <p className="text-muted">To obtain Credit information report from credit bureau kindly sure that enterd mobile number & email address must be associated with your bank & credit cards.</p>
                <hr/>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="currentLocation" id="currentLocation" onChange={handleFloatingLabels} />
                        <label htmlFor="currentLocation" className={formData.currentLocation && 'focused'}>Current Location<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="religion" id="religion" onChange={handleFloatingLabels} />
                        <label htmlFor="religion" className={formData.religion && 'focused'}>Religion<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={QuestionIcon} alt=""/>
                        <input type="text" className="form-control" name="uanNo" id="uanNo" onChange={handleFloatingLabels} />
                        <label htmlFor="uanNo" className={formData.uanNo && 'focused'}>12-Digit UAN Number (Latest)<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4 d-flex align-items-center">
                    <div className="form-group">
                      <div className="form-check">
                        <input type="checkbox" className="form-check-input" name="noUAN" id="noUAN"/>
                        <label htmlFor="noUAN" className="form-check-label">I don’t have a UAN</label>
                      </div>
                    </div>
                  </div>
                </div>

                <h6 className="fnt-smi-bld">EPF Nomination</h6>

                <div className="row">
                  <div className="col-sm-8 col-md-12 col-xl-8 d-flex align-items-center">
                    <div className="form-group">
                      <div className="form-check">
                        <input type="checkbox" className="form-check-input" name="epfNomination" id="epfNomination" checked="true" readonly disabled/>
                        <label htmlFor="epfNomination" className="form-check-label text-danger">I here by nominate the person/cancel the nomination made bu me previously and person mentioned below to receive the amount standing to my credit in employees provident fund in the vent of my death.</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="epfNomineeName" id="epfNomineeName" onChange={handleFloatingLabels} />
                        <label htmlFor="epfNomineeName" className={formData.epfNomineeName && 'focused'}>Nominee Name<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="epfNomineeRelation" id="epfNomineeRelation" onChange={handleFloatingLabels} />
                        <label htmlFor="epfNomineeRelation" className={formData.epfNomineeRelation && 'focused'}>Relationship<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CalendarIcon}/>
                        <input type="text" className="form-control" name="epfNomineeDOB" id="epfNomineeDOB" onChange={handleFloatingLabels} />
                        <label htmlFor="epfNomineeDOB" className={formData.epfNomineeDOB && 'focused'}>Nominee DOB<sup className="text-danger">*</sup></label>
                      </div>
                      <small className="text-muted">Age : 51 Years</small>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={PercentIcon} alt=""/>
                        <input type="text" className="form-control" name="epfNomineeAmountShare" id="epfNomineeAmountShare" onChange={handleFloatingLabels} />
                        <label htmlFor="epfNomineeAmountShare" className={formData.epfNomineeAmountShare && 'focused'}>Nominee Amount Share<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="epfNomineeAddress" id="epfNomineeAddress" onChange={handleFloatingLabels} />
                        <label htmlFor="epfNomineeAddress" className={formData.epfNomineeAddress && 'focused'}>Nominee Address<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <h6 className="fnt-smi-bld">EPS Nomination</h6>

                <div className="row">
                  <div className="col-sm-8 col-md-12 col-xl-8 d-flex align-items-center">
                    <div className="form-group">
                      <div className="form-check">
                        <input type="checkbox" className="form-check-input" name="epfNomination" id="epfNomination" checked="true" readonly disabled/>
                        <label htmlFor="epfNomination" className="form-check-label text-danger">I here by nominate the person/cancel the nomination made bu me previously and person mentioned below to receive the amount standing to my credit in employees provident fund in the vent of my death.</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <input type="text" className="form-control" name="epsNomineeName" id="epsNomineeName" onChange={handleFloatingLabels} />
                        <label htmlFor="epsNomineeName" className={formData.epsNomineeName && 'focused'}>Name of Family Member<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="epsNomineRelation" id="epsNomineRelation" onChange={handleFloatingLabels} />
                        <label htmlFor="epsNomineRelation" className={formData.epsNomineRelation && 'focused'}>Relationship<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <input type="text" className="form-control" name="epsNomineAge" id="epsNomineAge" onChange={handleFloatingLabels} />
                        <label htmlFor="epsNomineAge" className={formData.epsNomineAge && 'focused'}>Age of Family Member<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-8">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <input type="text" className="form-control" name="epsNomineAddress" id="epsNomineAddress" onChange={handleFloatingLabels} />
                        <label htmlFor="epsNomineAddress" className={formData.epsNomineAddress && 'focused'}> Address of Family Member<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3 mb-3">
                  <div className="col-auto">
                    <button className="btn btn-outline-primary">+ Add Family Memeber (optional)</button>
                  </div>
                  <div className="col-auto">
                    <small className="text-muted">You may add upto 4 family members</small>
                  </div>
                </div>

                <h6 className="fnt-smi-bld">Composite declartion form 11: Employee Provident Fund Organization</h6>

                <div className="row mb-3">
                  <div className="col-md-8">

                    <label className="d-block w-100">Were you a earlier member of emplyees provident fund organization?</label>
                      
                      <div className="form-check form-check-inline mr-4">
                        <input type="radio" className="form-check-input" name="earlierMemberOfEPF" id="earlierMemberOfEPFYes" value="Yes" checked="true" />
                        <label htmlFor="earlierMemberOfEPFYes" className="form-check-label">Yes</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input type="radio" className="form-check-input" name="earlierMemberOfEPF" id="earlierMemberOfEPFNo" value="No" />
                        <label htmlFor="earlierMemberOfEPFNo" className="form-check-label">No</label>
                      </div>

                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-8">

                    <label className="d-block w-100">Were you a earlier member of emplyees pension scheme 1995?</label>
                      
                      <div className="form-check form-check-inline mr-4">
                        <input type="radio" className="form-check-input" name="earlierMemberOfEPS" id="earlierMemberOfEPSYes" value="Yes" checked="true" />
                        <label htmlFor="earlierMemberOfEPSYes" className="form-check-label">Yes</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input type="radio" className="form-check-input" name="earlierMemberOfEPS" id="earlierMemberOfEPSNo" value="No" />
                        <label htmlFor="earlierMemberOfEPSNo" className="form-check-label">No</label>
                      </div>

                  </div>
                </div>

                <h6 className="fnt-smi-bld mb-3">Graduity Details Form</h6>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <input type="text" className="form-control" name="graduityDetailsBankAcc" id="graduityDetailsBankAcc" onChange={handleFloatingLabels} />
                        <label htmlFor="graduityDetailsBankAcc" className={formData.graduityDetailsBankAcc && 'focused'}>Bank Account Number<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="graduityDetailsIFSC" id="graduityDetailsIFSC" onChange={handleFloatingLabels} />
                        <label htmlFor="graduityDetailsIFSC" className={formData.graduityDetailsIFSC && 'focused'}>IFSC Code of Branch<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4 d-flex align-items-center">
                    <div className="form-group">
                      <p>Notice date when your excluded your spouse from family</p>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CalendarIcon} alt=""/>
                        <input type="text" className="form-control" name="graduityDetailsExcludedSpouseDate" id="graduityDetailsExcludedSpouseDate" onChange={handleFloatingLabels} />
                        <label htmlFor="graduityDetailsExcludedSpouseDate" className={formData.graduityDetailsExcludedSpouseDate && 'focused'}>Select Date<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <h6 className="fnt-smi-bld mb-3">Graduity Nominee</h6>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="graduityNomineeName" id="graduityNomineeName" onChange={handleFloatingLabels} />
                        <label htmlFor="graduityNomineeName" className={formData.graduityNomineeName && 'focused'}>Nominee Name<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="graduityNomineeRelation" id="graduityNomineeRelation" onChange={handleFloatingLabels} />
                        <label htmlFor="graduityNomineeRelation" className={formData.graduityNomineeRelation && 'focused'}>Relationship<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CalendarIcon}/>
                        <input type="text" className="form-control" name="graduityNomineeDOB" id="graduityNomineeDOB" onChange={handleFloatingLabels} />
                        <label htmlFor="graduityNomineeDOB" className={formData.graduityNomineeDOB && 'focused'}>Nominee DOB<sup className="text-danger">*</sup></label>
                      </div>
                      <small className="text-muted">Age : 51 Years</small>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={PercentIcon} alt=""/>
                        <input type="text" className="form-control" name="graduityNomineeAmountShare" id="graduityNomineeAmountShare" onChange={handleFloatingLabels} />
                        <label htmlFor="graduityNomineeAmountShare" className={formData.graduityNomineeAmountShare && 'focused'}>Nominee Amount Share<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button>
                    <button className="btn btn-primary btn-lg btn-block mt-3">Save</button>
                  </div>
                </div>
              </form>

              {/*Form*/}
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </section>

      </>
    );
}
export default CandidateOnboardingDetails;